module.exports = __webpack_public_path__ + "static/media/full-logo-web.a043e3ad.png";